import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';

const useTrackWelcomeCardLinkClicked = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(
    ({ link }: { link: string }) => {
      const trackProductAnalytics = trackAnalytics(productEvents);

      trackProductAnalytics('Welcome Card Clicked', {
        'Link Clicked': link,
      });
    },
    [productEvents],
  );

  return trackCallback;
};

export default useTrackWelcomeCardLinkClicked;
